export const config = {
  oldClientColorName: process.env.REACT_OLD_CLIENT_COLOR_NAME || "สีชมพูม่วง",
  defaultListPath: `/list?isNotOnlyColorName=${
    process.env.REACT_OLD_CLIENT_COLOR_NAME || "สีชมพูม่วง"
  }`,
}
